/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-22 09:36:38
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyFormPane from "../BsyFormPane";
import BsyMaskLayer from "../BsyMaskLayer";

export default class BsySubformLinkQuery extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-subform-link-query",
      allowBlank: !0,
      linkFields: [],
      linkForm: null,
      layoutSize: {},
      itemsPerPage: 20,
      showMode: "one", //单条 多条的显示
      showType: "none", // none 默认模式 label 标题模式
      allowAdd: !1, //是否有创建数据的权限
      cls4FullScreen: "block-fullscreen",
      refType: null,
      onGetFilter: null,
      onRelyDone: null,
      popupFormPath: [],
      ...props,
      enable: true,
    });
    this.state = {
      data: props.value ? props.value : {},
      formName: "",
    };
    this.limit = 20;
    this.page = 0;
    this.componentKey = "";
    this.renderIndex = 0;
    this.isFullScreen = false;
  }

  componentDidMount() {
    super.componentDidMount();
    this.page = 0;
    let filter =
      BsyUtils.applyFunc(this, this.options.onGetFilter, [], !1) || {};
    if (BsyUtils.isObjectEmpty(this.state.data)) {
      this.reload(filter);
    }
  }

  reload = (a, s) => {
    const { showMode, showType } = this.options;

    this.filter = a;
    this.page = 0;
    this.loadData();
  };

  setValue = (data) => {
    this.value = data;
    this.renderIndex = this.renderIndex || 0;
    this.renderIndex++;
    if (data) {
      this.setState({
        data: data,
        formName: null,
      });
    } else {
      this.setState({
        data: {},
      });
    }
  };

  getValue = () => {
    return this.value;
  };

  loadData = (config, cb) => {
    const { limit } = this;
    const { showMode } = this.options;
    this.dataMap = {};
    let that = this;

    if (!this.filter || BsyUtils.isObjectEmpty(this.filter.cond)) {
      if (!that.options.onStopEdit) {
        that.field.setValue({});
        return;
      }

      BsyUtils.applyFunc(that, that.options.onStopEdit, [null, {}, that], !1);
      this.setState({
        data: {},
      });
      return;
    }

    let fields = [...this.options.linkFields];
    if (showMode !== "many") {
      fields = [];
      BsyUtils.forEach(this.options.linkFields, (a1, b1) => {
        fields.push(b1.name);
      });
    }

    let data = {
      designAppId: this.options.designAppId,
      designEntryId: this.options.designEntryId,
      appId: this.options.appId,
      entryId: this.options.entryId,
      formId: this.options.linkForm,
      fields: fields,
      filter: this.filter,
      isNewFilter: this.filter
        ? this.filter.hasOwnProperty("cond")
          ? true
          : false
        : false,
      limit: showMode === "many" ? (config ? config.limit : limit) : undefined,
      skip:
        showMode === "many"
          ? config
            ? config.skip
            : this.page * limit
          : undefined,
      multi: showMode === "many" ? true : undefined,
      refAppId: this.options.refAppId,
      widgetName: this.options.widgetName,
      subformName: this.options.subform,
    };
    React.axios(`/data/filter`, data, { autoShowMsg: true })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          if (!that.options.onStopEdit) {
            that.field.setValue(res.data.result);
            return;
          }

          BsyUtils.applyFunc(
            that,
            that.options.onStopEdit,
            [res.data, null, that],
            !1
          );
          if (showMode === "many") {
            cb && cb(res.data.result);
            this.setState({
              data: res.data.result,
              formName: res.data.formName,
            });
          } else {
            this.setState({
              data: res.data.result,
            });
          }
        });
      })
      .catch((res) => {
        const { code } = res.data;
        if (code === 3000 || code === 400) {
          // that.errorWidget = b;
          let text = React.language("field.rely.network.error", {
            name: this.options.label || this.options.labelStyle,
          });
          tipAlert({
            type: "warning",
            msg: text,
          });
        } else {
          return !1;
        }
      });
  };

  renderField = (item) => {
    const { data } = this.state;
    let value = data
      ? data.result
        ? data.result[item.name]
        : data[item.name]
      : "";

    let config = { ...item };
    config.value = value;
    config.enable = false;

    return <div className="link-field">{BsyUtils.createWidget(config)}</div>;
  };

  showData = (data) => {
    if (this.getFormMode() === "preview") {
      tipAlert({
        type: "warning",
        msg: React.language("preview.view.data"),
      });
      return;
    }
    const {
      linkFields,
      showType,
      entryId,
      refAppId,
      linkForm,
      popupFormPath,
      formId,
      appId,
      subform,
      widgetName,
      designAppId,
      designEntryId
    } = this.options;
    if (window.FX.STATIC.FTOKEN) {
      var d = {
        data: data,
        fields: linkFields,
        header: linkFields,
      };
      this.onShowData(d);
      return;
    }

    var d1 = BsyUtils.checkRefApp({
      appId: refAppId,
      entryId: linkForm,
      formId: linkForm,
      dataId: data._id,
      autoShowMsg: true,
      popupFormPath: (popupFormPath||[]).concat({
        appId: designAppId,
        entryId: designEntryId,
        formId: linkForm,
        subform: subform,
        widgetName: widgetName,
        islinkquery: true,
      }),
    });

    React.axios("/data/dataView", d1, { autoShowMsg: true })
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            var data = { ...res.data, ...d1 };
            data.header = res.data.fields;
            data.multiTabs = res.data.formTabs;
            data.formTabsStyle = res.data.formTabsStyle || {};
            data.fields = res.data.fields;
            data.needFetchViewData = false;
            data.items = res.data.form.items;
            data.fieldShowRules = res.data.form.fieldShowRules;
            data.subformFieldShowRules = res.data.form.subformFieldShowRules; 
            data.ptlist = res.data.ptlist;
            data.height = "100%";
            data.hasCopy = false;
            data.hasShareBtn = false;
            data.hasFlow = !res.data.hasCoop && res.data.hasFlow;
            data.hasFlowBtn =
              res.data.flow_close ||
              res.data.flow_replace_node ||
              res.data.flow_transfer;
            data.hasFlowLog = res.data.flow_log;
            this.onShowData(data);
          },
          () => {
            var d = {
              data: data,
              fields: linkFields,
              needFetchViewData: false,
              header: linkFields,
              hasShareBtn: false,
              height: "100%",
            };
            this.onShowData(d);
          }
        );
      })
      .catch((res) => {
        var d = {
          data: data,
          fields: linkFields,
          needFetchViewData: false,
          header: linkFields,
          hasShareBtn: false,
          optAuth: null,
          height: "100%",
        };
        this.onShowData(d);
      });
  };

  onShowData = (config) => {
    if (this.props.onShowData) {
      this.props.onShowData(config);
    } else {
      let layerRef = null;
      BsyMaskLayer({
        customCls: "fadein-right",
        onMaskClick: (event) => {
          // if (event.target.classList.contains("BsyMaskLayer")) {
          //   layerRef.close();
          // }
        },
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <BsyFormPane
              {...config}
              mode={"view"}
              onClose={(status, data) => {
                layerRef && layerRef.close();
              }}
            />
          );
        },
      });
    }
  };

  renderSingeData = () => {
    const { linkFields, showType } = this.options;

    if (showType === "label") {
      const { data } = this.state;
      let value = "";
      const def = data.result ? data.result : data;
      if (data) {
        if (def) {
          value = def["label"];
        } else {
          if (def[linkFields[0].name]) {
            value = def[linkFields[0].name];
          }
        }
      }

      return (
        <div className={"link-field " + showType}>
          <div
            className="bsy_form_item_disable"
            data-watermark={React.language("content.empty")}
            title={value}
            onClick={(e) => {
              if (!value) {
                return;
              }
              this.showData(def);
            }}
          >
            {value ? (
              <span className="item" title={value}>
                {value}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="field-list" key={"render" + this.renderIndex}>
        {linkFields.map((e) => {
          return this.renderField(e);
        })}
      </div>
    );
  };

  render() {
    const { cssName } = this.options;

    return (
      <div className={cssName} ref={this.element}>
        {this.renderSingeData()}
      </div>
    );
  }
}
